import { render, staticRenderFns } from "./EditarVagas.vue?vue&type=template&id=1c503df6"
import script from "./EditarVagas.vue?vue&type=script&lang=js"
export * from "./EditarVagas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports